module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tab fixedTop"
  }, [_c('a', {
    class: {
      on: _vm.type === 0
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.type = 0
      }
    }
  }, [_vm._v("最近更新")]), _vm._v(" "), _c('a', {
    class: {
      on: _vm.type === 1
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.type = 1
      }
    }
  }, [_vm._v("最新发布")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "more": _vm.more
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8090910c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/bookshelf/latest.vue
// module id = 338
// module chunks = 0